import React, { Component } from 'react';
import { Row, Col, Input, Button } from 'reactstrap';
import { BlankCard } from '../Base/Common/CommonUIComponents';
import { FormattedMessage, injectIntl } from 'react-intl';
import Authorization from '../Base/Authorization';
import { ImageDragAndDrop } from './ImageDragAndDrop';
import { deleteAPI, postMultiPartAPI, putAPI } from '../Base/API';
import { handleNotification } from '../Base/Common/Notification';

class VoucherConfigStepImages extends Component {
    constructor(props) {
        super(props);
        this.state = {
            block: false,
            error: [],
            dragSrcIndex: null,
            dragOverIndex: null,
            hoveredIndex: null,
        };
    }


    handleDrop = (files) => {
        for (var i = 0; i < files.length; i++) {
            if (!(files[i] && files[i].size <= 1048576)) {
                handleNotification('', <FormattedMessage id="CardConfigWizard.PleaseSelectAFileLessThan" />, <FormattedMessage id="CardConfigWizard.SelectedFileIsTooBig" />, 'info');
                return;
            }
        }

        this.setState({ block: true }, () => {
            const formData = new FormData();
            formData.append('file', files[0]);
            const url = `/api/Voucher/v1/Config/UploadImages/${this.props.voucherConfigId}`;

            postMultiPartAPI(result => {
                const { data, error } = result;
                const errorMessage = [];
                if (error) {
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    this.setState({ error: errorMessage, block: false });
                    return;
                }
                if (data) {
                    handleNotification(data, <FormattedMessage id="EditVoucher.PhotoUploadedSuccessfully" />, <FormattedMessage id="EditVoucher.Success" />);

                    const updatedList = [...this.props.voucherImageList, data.response[0]];
                    
                    this.setState({ error: errorMessage, block: false }, () =>
                        this.props.updateImageList(updatedList)
                    );
                    return;
                }
                this.setState({ block: false });
            }, url, formData);
        });
    }

    deleteImage = (id) => {
        this.setState({ block: true }, () => {
            deleteAPI(result => {
                const { data, error } = result;
                if (error) {
                    const errorMessage = [{ message: error.message, stack: error.stack, messageType: 'danger' }];
                    this.setState({ error: errorMessage, block: false });
                    return;
                }
                if (data) {
                    handleNotification(data, <FormattedMessage id="EditVoucher.ImageDeleted" />, <FormattedMessage id="EditVoucher.Success" />);
                    const updatedList = [...this.props.voucherImageList].filter(el => el.id !== id);
                    this.setState({ error: [], block: false }, () =>
                        this.props.updateImageList(updatedList)
                    );
                    return;
                }
                this.setState({ block: false });
            }, '/api/Voucher/v1/Config/DeleteImage/' + id);
        });
    }

    onImageDragStart = (e, index) => {
        this.setState({ dragSrcIndex: index });
        e.dataTransfer.effectAllowed = 'move';
    }

    onImageDragOver = (e, index) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        if (this.state.dragOverIndex !== index) this.setState({ dragOverIndex: index });
    }

    onImageDragLeave = (index) => {
        if (this.state.dragOverIndex === index) this.setState({ dragOverIndex: null });
    }

    onImageDrop = (e, dropIndex) => {
        e.preventDefault();
        e.stopPropagation();
        const { dragSrcIndex } = this.state;
        if (dragSrcIndex === null || dragSrcIndex === dropIndex) {
            this.setState({ dragSrcIndex: null, dragOverIndex: null });
            return;
        }

        const imageList = [...this.props.voucherImageList];
        imageList[dragSrcIndex].index = dropIndex;
        imageList[dropIndex].index = dragSrcIndex;

        const body = { request: imageList };

        this.setState({ block: true, dragSrcIndex: null, dragOverIndex: null }, () => {
            putAPI(result => {
                const { data, error } = result;
                const errorMessage = [];
                if (error) {
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    this.setState({ error: errorMessage, block: false });
                    return;
                }
                if (data && data.response) {
                    handleNotification(data, <FormattedMessage id="EditVoucher.ReorderImagesSuccess" />, <FormattedMessage id="EditVoucher.Success" />);
                    const updatedList = [...imageList].sort((a, b) => a.index - b.index);
                    this.setState({ error: errorMessage, block: false }, () =>
                        this.props.updateImageList(updatedList)
                    );
                    return;
                }
                this.setState({ error: errorMessage, block: false });
            }, `/api/Voucher/v1/Config/ReorderImages/${this.props.voucherConfigId}`, body);
        });
    }

    onImageDragEnd = () => this.setState({ dragSrcIndex: null, dragOverIndex: null, hoveredIndex: null });

    updateImageProps = (img, altText) => {
        this.setState({ block: true }, () => {
            img.altText = altText;
            img.voucherTypeId = this.props.voucherConfigId;
            delete img.url;

            putAPI(result => {
                const { data, error } = result;
                const errorMessage = [];
                if (error) {
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    this.setState({ error: errorMessage, block: false });
                    return;
                }
                if (data) {
                    if (data.response) {                            
                        handleNotification(data, <FormattedMessage id="CardConfigWizard.ImageUpdatedSuccessfully" />, <FormattedMessage id="EditVoucher.Success" />);

                        const images = [...this.props.voucherImageList];
                        const index = images.findIndex(el => el.id === img.id);
                        
                        if (index !== -1) {
                            images[index].altText = altText;
                        }
                        
                        this.setState({ error: errorMessage, block: false }, () =>
                            this.props.updateImageList(images)
                        );

                        return;
                    }
                }
                this.setState({ block: false });
            }, `/api/Voucher/v1/Config/UpdateImageProps/${img.id}`, JSON.stringify({ request: img }));
        });
    }


    render() {
        const { block, voucherImageList, canEditVoucher } = this.props;
        const { dragSrcIndex, dragOverIndex, hoveredIndex } = this.state;

        return (
            <BlankCard block={block || this.state.block} error={this.state.error}>
                <Row className="align-items-center mb-1">
                    <Col>
                        <h5 className="mb-2">
                            <FormattedMessage id="CardConfigWizard.Images" />
                        </h5>
                    </Col>
                    <Col className="col-auto text-muted" style={{ fontSize: '0.85rem' }}>
                        {voucherImageList?.length || 0} <FormattedMessage id="CardConfigWizard.Images" />
                    </Col>
                </Row>
                <hr className="my-2 border-host" />

                <div className="image-grid" onDragEnd={this.onImageDragEnd}>
                    {canEditVoucher &&
                        <Authorization
                            perform="cardConfigWizard:addImage"
                            yes={() => (
                                <div className="image-wrapper">
                                    <ImageDragAndDrop handleDrop={this.handleDrop} />
                                </div>
                            )}
                            no={() => <div />}
                        />
                    }

                    {voucherImageList?.map((file, k) => {
                        const isDragging = dragSrcIndex === k;
                        const isDragOver = dragOverIndex === k && dragSrcIndex !== k;
                        const isHovered = hoveredIndex === k;

                        return (
                            <ImageCard
                                key={file.id || k}
                                file={file}
                                index={k}
                                canEditVoucher={canEditVoucher}
                                isDragging={isDragging}
                                isDragOver={isDragOver}
                                isHovered={isHovered}
                                onDragStart={(e) => this.onImageDragStart(e, k)}
                                onDragOver={(e) => this.onImageDragOver(e, k)}
                                onDragLeave={() => this.onImageDragLeave(k)}
                                onDrop={(e) => this.onImageDrop(e, k)}
                                onDragEnd={this.onImageDragEnd}
                                onMouseEnter={() => this.setState({ hoveredIndex: k })}
                                onMouseLeave={() => this.setState({ hoveredIndex: null })}
                                deleteImage={this.deleteImage}
                                updateImageProps={this.updateImageProps}
                                intl={this.props.intl}
                            />
                        );
                    })}

                    {(!voucherImageList || voucherImageList.length === 0) &&
                        <div className="text-center text-muted py-5">
                            <i className="fa-solid fa-image fa-3x mb-3" style={{ opacity: 0.25 }} />
                            <div>
                                <FormattedMessage id="CardConfigWizard.NoImages" />
                            </div>
                        </div>
                    }
                </div>

            </BlankCard>
        );
    }
}

export default injectIntl(VoucherConfigStepImages);


const ImageCard = ({ file, index, canEditVoucher, isDragging, isDragOver, isHovered, onDragStart, onDragOver, onDragLeave, onDrop, onDragEnd, onMouseEnter, onMouseLeave, deleteImage, updateImageProps, intl }) => {
    const [editingAlt, setEditingAlt] = React.useState(false);
    const [altValue, setAltValue] = React.useState(file.altText || '');

    React.useEffect(() => {
        if (!editingAlt) setAltValue(file.altText || '');
    }, [file.altText, editingAlt]);

    const handleAltBlur = (e) => {
        if (e.relatedTarget && e.relatedTarget.closest('.image-card-alt-actions')) return;

        setEditingAlt(false);
    };

    const handleAltSave = () => {
        setEditingAlt(false);
        
        if (altValue !== file.altText) {
            updateImageProps({...file }, altValue);
        }
    };

    const handleAltKeyDown = (e) => {
        if (e.key === 'Enter') handleAltSave();
    };

    return (
        <div
            className={`bg-white image-wrapper${isDragging ? ' dragging' : ''}${isDragOver ? ' drag-over' : ''}`}
            draggable={!!canEditVoucher}
            onDragStart={onDragStart}
            onDragOver={onDragOver}
            onDragLeave={onDragLeave}
            onDrop={onDrop}
            onDragEnd={onDragEnd}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <div className="image-photo-container">
                <img
                    src={file.url}
                    alt={altValue || `voucher-${index + 1}`}
                    draggable="false"
                />

                <div className={`image-card-overlay${isHovered ? ' hovered' : ''}`}>
                    {canEditVoucher &&
                        <Authorization
                            perform="cardConfigWizard:deleteImage"
                            yes={() => (
                                <button
                                    className={`image-card-delete-btn${isHovered ? ' visible' : ''}`}
                                    onClick={(e) => { e.stopPropagation(); if (file.id) deleteImage(file.id); }}
                                >
                                    <i className="fa-solid fa-xmark" />
                                </button>
                            )}
                            no={() => <div />}
                        />
                    }
                    <span className="image-card-badge font_size_xxxs">#{index + 1}</span>
                </div>

                {canEditVoucher && isHovered &&
                    <div className="image-card-drag-handle">
                        <i className="fa-solid fa-grip-horizontal" />
                    </div>
                }
            </div>

            <div className="d-flex align-items-center bg-white p-2">
                <b className="font_size_xxxs text-muted text-uppercase text-bold mr-2 pr-1">Alt</b>
                {canEditVoucher ? (
                    editingAlt ? (
                        <>
                            <Input
                                autoFocus
                                className="font_size_xxs px-1"
                                value={altValue}
                                onChange={(e) => setAltValue(e.target.value)}
                                onBlur={handleAltBlur}
                                onKeyDown={handleAltKeyDown}
                                onClick={(e) => e.stopPropagation()}
                                onDragStart={(e) => e.stopPropagation()}
                                placeholder={intl.formatMessage({ id: "CardConfigWizard.AddAltText" })}
                                maxLength={255}
                                style={{ height: '21px', minHeight: '21px' }}
                            />
                            <div className="image-card-alt-actions ml-2">
                                <Button className="btn-host btn-sm d-flex align-items-center justify-content-center p-0" onClick={(e) => { e.stopPropagation(); handleAltSave(); }} style={{ height: '22px', width: '22px' }}>
                                    <i className="fa-solid fa-xs fa-check" />
                                </Button>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className={`font_size_xxs text-truncate text-muted pointer w-100 ${!altValue ? ' font-italic' : ''} pr-2`} title={altValue} onClick={(e) => { e.stopPropagation(); setEditingAlt(true); }}>
                                {altValue || intl.formatMessage({ id: "CardConfigWizard.AddAltText" })}
                            </div>
                            <Button
                                className="btn-host btn-sm d-flex align-items-center justify-content-center p-0 ml-auto flex-shrink-0"
                                onClick={(e) => { e.stopPropagation(); setEditingAlt(true); }}
                                title={intl.formatMessage({ id: "CardConfigWizard.ClickToEditAltText" })}
                                style={{ height: '22px', width: '22px' }}
                            >
                                <i className="fa-solid fa-xs fa-pen" />
                            </Button>
                        </>
                    )
                ) : (
                    <span className='font_size_xxs text-truncate text-muted' title={altValue}>
                        {altValue || '—'}
                    </span>
                )}
            </div>
        </div>
    );
};